angular
  .module('eventCode')
  .component('eventCode', {
    template: require('./event-code.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function EventCodeViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $rootScope.mainmenu = 'coupons';
        $rootScope.menu = 'eventcode';
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;

        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.codes = [];
        this.total_count = 0;
        this.newCode = {
          CODE: '',
          VALID_AT: '',
          NOTE: '',
          MAX_COUNT: 40,
        };

        this.paging = (page) => {
          $resource(`${APIURL}/admin/eventcode`).get({ page: page - 1 },
            (data) => {
              this.codes = Array.isArray(data.codes) ? data.codes : [];
              this.total_count = data.total_count || 0;
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.openCreate = () => {
          const d = new Date();
          d.setFullYear(d.getFullYear() + 1);
          this.newCode = {
            CODE: '#',
            VALID_AT: d.toISOString().slice(0, 10),
            NOTE: '',
            MAX_COUNT: 40,
          };
          window.jQuery('#modal-event-code-create').modal('show');
        };

        this.submitCreate = () => {
          if (!this.newCode.CODE || String(this.newCode.CODE).replace(/^#/, '').length < 1) {
            alert($translate.instant('CODE를 입력해주세요.'));
            return;
          }
          if (!this.newCode.VALID_AT) {
            alert($translate.instant('올바른 유효기간:만료일을 입력해주세요.(예:2016-01-01)'));
            return;
          }
          if (!this.newCode.NOTE) {
            alert($translate.instant('발급사유를 입력해주세요.'));
            return;
          }
          $resource(`${APIURL}/admin/eventcode`).save(this.newCode).$promise
            .then(() => {
              window.jQuery('#modal-event-code-create').modal('hide');
              this.paging(1);
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.paging(1);
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/event-code/event-code.component.js